<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HnEbF3/tc-custom/9781685506889.jpg?1728724800217" alt="This image is the cover for the book Rainbow Connection Box Set"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rainbow Connection Box Set
      </h1>
      <p class="bookDescription body article font2">
        <p>As a rising freshman at an out-of-state college, Beau Watkins is determined to find out who he really is behind the fake it 'til you make it attitude. He joins Rainbow Connection, the gay student alliance, hoping to find himself. Instead, he meets Vin Reyes.<br/><br/>All three books in Lynn Townsend's best-selling Rainbow Connection series are collected together into a box set for the first time! Contains the stories:<br/><br/><strong>On a Roll</strong>: College is all about finding yourself, but nobody told Beau it was also about losing your heart. Can a farm kid from Tennessee make it work with a flamboyant rich man with a hidden past?<br/><br/><strong>Got the Blues</strong>: Beau gave up everything to be with his boyfriend Vin. But Vin turns to alcohol to drown his pain, and worse, a handsome transfer student is a little too interested in Beau. Vin throws away everything that's made him happy with both hands, terrified of his own feelings of inadequacy. Will they be able to find their place together in the world?<br/><br/><strong>A Classic Blunder</strong>: Beau and Vin have mended their differences, but that doesn't mean everything is back the way it was. Vin’s relationship with Beau has never been stronger ... until an unexpected email threatens to topple everything they've build together.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynn Townsend
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c10b2e56